module.exports = __webpack_public_path__ + "img/exam_before_confirm.4d4b5969.svg";